var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-layout py-5"},[_c('div',{staticClass:"con d-flex flex-column align-items-center"},[_c('div',{on:{"click":_vm.onLogoClick}},[_c('auth-logo',{staticClass:"mb-5 logo"})],1),_c('router-view')],1),_c('img',{staticClass:"b-image",attrs:{"src":require("@/assets/images/onboarding/login_forgot_onboarding.webp"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }